<div class="flex grid-cols-2 flex-col gap-4 md:grid md:justify-between">
  <h2
    class="text-nowrap text-2xl font-extrabold leading-[1.3125rem] text-mango-black17"
  >
    Configs
  </h2>
</div>

<!-- Filter -->
<div class="flex gap-3">
  <app-filters
    [filters]="filterStructure"
  ></app-filters>
  <app-table-refresh class="mt-5" [tableKey]="'configurations'"></app-table-refresh>
</div>

<div class="mt-[0.94rem] overflow-x-auto sm:-mx-6 lg:-mx-8" *appHasPermission="'get_all_configs'">
  <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
    <div
      class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
      (click)="closeEdit()"
    >
      <table class="min-w-full leading-normal">
        <thead>
          <tr>
            <th
              class="border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold uppercase tracking-wider text-gray-600"
            >
              S/N
            </th>

            <th
              class="border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold uppercase tracking-wider text-gray-600"
            >
              Key
            </th>

            <th
              class="border-b-2 border-gray-200 bg-gray-100 px-5 py-5 text-left text-xs font-semibold uppercase tracking-wider text-gray-600"
            >
              Value
            </th>
          </tr>
        </thead>

        <tbody>
          @for (config of (configList$ | async); track config.key; let i = $index) {
            <tr>
              <!-- S/N -->
              <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                {{ i + 1 }}
              </td>

              <!-- KEY -->
              <td class="border-b border-gray-200 bg-white px-5 py-5 text-sm">
                <p class="whitespace-no-wrap font-medium text-gray-900">
                  {{ config.key }}
                </p>
              </td>

              <!-- VALUE -->
              <td 
                class="border-b border-gray-200 bg-white px-5 py-5 text-sm"
                (click)="$event.stopPropagation()"
              >
                <!-- READ MODE -->
                <span
                  *ngIf="editingKey !== config.key"
                  class="cursor-pointer text-gray-700 hover:underline"
                  [style.cursor]="'url(\'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iIzM3NDE1MSIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ij48cGF0aCBkPSJNMjEuNzMxIDIuMjY5YTIuNjI1IDIuNjI1IDAgMCAwLTMuNzEyIDBsLTEuMTU3IDEuMTU3IDMuNzEyIDMuNzEyIDEuMTU3LTEuMTU3YTIuNjI1IDIuNjI1IDAgMCAwIDAtMy43MTJaTTE5LjUxMyA4LjE5OWwtMy43MTItMy43MTItMTIuMTUgMTIuMTVhNS4yNSA1LjI1IDAgMCAwLTEuMzIgMi4yMTRsLS44IDIuNjg1YS43NS43NSAwIDAgMCAuOTMzLjkzM2wyLjY4NS0uOGE1LjI1IDUuMjUgMCAwIDAgMi4yMTQtMS4zMkwxOS41MTMgOC4yWiIgLz48L3N2Zz4=\') 0 16, auto'"
                  (click)="enableEdit(config.key)"
                >
                  {{ (config.value || 'Click to set value') | truncate:25}}
                </span>

                <!-- EDIT MODE -->
                <div class="flex items-center gap-2" *ngIf="editingKey === config.key">
                  <app-input
                    inputClass="input--padding"
                    placeholder="Enter value"
                    [formControl]="rowForms[config.key]"
                    (click)="$event.stopPropagation()"
                  ></app-input>
                  <button
                    mango-button
                    size="sm"
                    *appHasPermission="'update_config'"
                    [disabled]="
                      rowForms[config.key].pristine ||
                      rowForms[config.key].invalid ||
                      (isUpdating$ | async)!
                    "
                    (click)="saveRow(config.key)"
                  >
                    {{ (isUpdating$ | async) ? 'Saving...' : 'Save' }}
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <!-- Pagination -->
      <app-table-navigator
        [total]="(totalCount$ | async) || 0"
        (onNavigation)="navigate($event)"
      ></app-table-navigator>
    </div>
  </div>
</div>